import { useTranslation } from 'react-i18next';
import { Box, Typography, Container } from '@mui/material';

import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
// components
import Page from 'components/Page';
import { MotionContainer } from 'components/animate';
// assets
import PageNotFoundIllustration from 'assets/images/illuustration/illustration_404';
import imgSrc from 'assets/images/InVitro_Results_Server.png';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

export default function RoleBasedGuard() {
  const { t } = useTranslation();

  return (
    <Page title={t("popup.titles.accessDenid")} sx={{ height: 1 }}>
      <RootStyle>
        <Container component={MotionContainer}>
          <Box sx={{ maxWidth: 480, margin: 'auto', textAlign: 'center' }}>
            <m.div>
              <Typography variant="h3" paragraph color="primary">
                {t("popup.titles.accessDenid")}
              </Typography>
            </m.div>
            <Typography color="primary">
              {t("popup.canNotAccessPage")}
            </Typography>

            <m.div>
              <PageNotFoundIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
              <img
              alt="logo"
              src={imgSrc}
              style={{
                height: 'auto',
              }}
            />
            </m.div>

           
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
